import { render, staticRenderFns } from "./prepressdetail.vue?vue&type=template&id=65fa4aed&"
import script from "./prepressdetail.vue?vue&type=script&lang=js&"
export * from "./prepressdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports